import { DRFCrumb } from "@/common/components/drf-breadcrumb";
import { NotificationWrapper } from "../style";
import { Button } from "@/common/components/button";
import { getNotification } from "../data";
import useQuery from "@/hooks/useQuery";
import { STOCK_NOTIFICATION_URL } from "@/common/constants";
import { useApiCallHandling } from "@/hooks/useApiCallHandling";
import { useState } from "react";

export interface INofication {
  id: string;
  drug_name: string;
  description: string;
  batch_number: string;
  is_read?: boolean;
  current_stock: number;
}

const PharmacyHeadNotifications = () => {
  const makeRequest = useApiCallHandling();
  const { data: notificationData } = useQuery(STOCK_NOTIFICATION_URL);
  const [activeSelection, setActiveSelection] = useState<string | null>(null);
  const handleMarkAsRead = (id: string) => {
    setActiveSelection(id);
    makeRequest(
      STOCK_NOTIFICATION_URL + `/${id}`,
      "POST",
      {},
      () => {},
      () => {},
      () => {
        setActiveSelection(null);
      }
    );
  };
  return (
    <NotificationWrapper>
      <DRFCrumb
        currentPage="Notifications"
        previousPage="Dashboard"
        previousPageLink="/dashboard/pharmacy-head/inventory"
      />
      <div className="page-title">
        <h1>ALL DRUG INVENTORY</h1>
        <p>Manage your pharmaceutical inventory</p>
      </div>
      <div className="notify-wrapper">
        {notificationData?.length ? (
          getNotification(notificationData)?.map(
            (notification: INofication, index: number) => (
              <div className="notify-item" key={index}>
                <div>
                  <p>{notification?.description}</p>
                  <div>
                    <h2>
                      Drug: <span>{notification?.drug_name}</span>
                    </h2>
                    <h2>
                      Batch Number: <span>{notification?.batch_number}</span>
                    </h2>
                    <h2>
                      Current Stock: <span>{notification?.current_stock}</span>
                    </h2>
                  </div>
                </div>
                <Button
                  onClick={() => {
                    handleMarkAsRead(notification.id);
                  }}
                  loading={activeSelection === notification?.id}
                >
                  Mark as Read
                </Button>
              </div>
            )
          )
        ) : (
          <h1>No Notification Yet</h1>
        )}
      </div>
    </NotificationWrapper>
  );
};

export default PharmacyHeadNotifications;
